<template>
  <div class="flex flex-col justify-between h-full bg-white">
    <div class="flex justify-end">
      <img alt="" class="h-24" src="../assets/general/login-1.png" srcset=""/>
    </div>
    <div class="w-full flex flex-col gap-5 justify-center items-center">
      <WcTypography :title="$t('general.willBeBackSoon')"  size="vlg" weight="700" />
      <div class="sm:w-4/5 md:w1/2flex justify-center text-center">
        <WcTypography color="#727374" :title="$t('general.maintenanceNote')" />
      </div>
      <Button type="text" classes="underline" color="blue" @click="redirectToHome">
        <WcTypography :title="$t('general.refreshThePage')" color="blue" size="sm" />
      </Button>
    </div>
    <div>
      <img alt="" class="h-24" src="../assets/general/login-2.png" srcset=""/>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import WcTypography from '@/components/UILibrary/Typography/WcTypography.vue'
import { handleError } from '@/utils/request'
import { AppModule } from '@/store/modules/app'
import HealthResource from '@/api/health'

@Component({
  components: { WcTypography }
})
export default class MaintenanceMode extends Vue {
  healthResource = new HealthResource()
  async redirectToHome(): Promise<void> {
    try {
      await this.healthResource.list()
      AppModule.SetIsAppUnderMaintenanceMode(false)
      window.location.reload()
    } catch (error) {
      handleError(error, this.$message)
    }
  }
}
</script>

<style scoped>

</style>
